import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Servicios extends Component {
  render() {
    return (
        <div>
            <header className="w3-container">
                <h5><b> My Dashboard</b></h5>
            </header>
            <div className="w3-row-padding w3-margin-bottom">
                <div className="w3-quarter">
                    <div className="w3-container w3-red w3-padding-16">
                        <Link to={`/disenos`} >
                            <div className="w3-left"><i className="fas fa-coffee w3-xxxlarge"></i></div>
                            <div className="w3-right">
                                <h3></h3>
                            </div>
                            <div className="w3-clear"></div>
                            <h4>Diseños</h4>
                        </Link>
                    </div>
                </div>
                <div className="w3-quarter">
                    <div className="w3-container w3-blue w3-padding-16">
                        <Link to={`/reparacion`} >
                            <div className="w3-left"><i className="fas fa-toolbox w3-xxxlarge"></i></div>
                            <div className="w3-right">
                                <h3></h3>
                            </div>
                            <div className="w3-clear"></div>
                            <h4>Reparaciones</h4>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}

export default Servicios;


// WEBPACK FOOTER //
// ./src/Servicios/Servicios.js